import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CrudGenericsService } from '../common/crud-generics';
import { Environment, TicketsCausaRadice } from '../../models/-index';

@Injectable()
export class TicketsCausaRadiceService extends CrudGenericsService<TicketsCausaRadice, number> {
  // private base:string;;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/TicketsCausaRadice`);
    //  this.base = `${env.apiUrl}/api/RepartiTipo/`;
  }
}
